import { render, staticRenderFns } from "./Scoresranking.vue?vue&type=template&id=11c13bc0&scoped=true&"
import script from "./Scoresranking.vue?vue&type=script&lang=js&"
export * from "./Scoresranking.vue?vue&type=script&lang=js&"
import style0 from "./Scoresranking.vue?vue&type=style&index=0&id=11c13bc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c13bc0",
  null
  
)

export default component.exports